import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  buyBack,
  currentUser,
  forgotPassword,
  login,
  partnerSiteId,
  paypalAuthorize,
  doPaypalPurchase,
  purchase,
  registerUser,
  accountLocked,
  resetPassword,
  updateUser,
  view,
  voucher,
  voucherPurchase,
} from "../../service/login";

const initialState = {
  login: "",
  registerUser: "",
  barToken: "",
  currentUser: [],
  updateUser: [],
  forgotPassword: "",
  view: {},
  partnerSiteId: {},
  purchase: null,
  voucher: "",
  voucherPurchase: null,
  paypalAuthorize: "",
  doPaypalPurchaseValue: {},
  doPaypalPurchase: null,
  tokenExpiration: "",
  resetPassword: {},
  error: "",
};

export const fetchLogin = createAsyncThunk(
  "fetchContact/fetchContact",
  async (action, { getState, rejectWithValue }) => {
    switch (action.condition) {
      case "login":
        const reponse = await login(action.payload);
        return reponse;
      case "accountBlock":
        const accountBlockResponse = await accountLocked(action.payload);
        return accountBlockResponse;
      case "registerUser":
        const reponseRegister = await registerUser(action.payload);
        return reponseRegister;
      case "buyBack":
        const reponseBuyback = await buyBack(action.payload);
        return reponseBuyback;
      case "forgotPassword":
        const reponsePassword = await forgotPassword(action.payload);
        return reponsePassword;
      case "currentUser":
        const reponseUser = await currentUser(action.payload);
        return reponseUser;
      case "updateUser":
        const reponseUserUpdate = await updateUser(action.payload);
        return reponseUserUpdate;
      case "view":
        const reponseView = await view(action.payload);
        return reponseView;
      case "partnerSiteId":
        const reponsePartnerSiteId = await partnerSiteId(action.payload);
        return reponsePartnerSiteId;
      case "purchase":
        const reponsePurchase = await purchase(action.payload);
        return reponsePurchase;
      case "voucher":
        const reponseVoucher = await voucher(action.payload);
        return reponseVoucher;
      case "voucherPurchase":
        const responseVoucherPurchase = await voucherPurchase(action.payload);
        return responseVoucherPurchase;
      case "paypalAuthorize":
        const reponsePaypal = await paypalAuthorize(action.payload);
        return reponsePaypal;
      case "doPaypalPurchase":
        const reponsePaypalPurchase = await doPaypalPurchase(action.payload);
        return reponsePaypalPurchase;
      case "resetPassword":
        const reponseresetPassword = await resetPassword(action.payload);
        return reponseresetPassword;

      default:
        throw new Error("Invalid condition");
    }
  }
);

export const loginSlice = createSlice({
  name: "fetchLogin",
  initialState,
  reducers: {
    clearData: (state) => {
      state.error = "";
      state.success = "";
      state.forgotPassword = "";
      state.currentUser = [];
      state.purchase = null;
      state.doPaypalPurchase = null;
      state.voucherPurchase = null;
    },
    clearView: (state) => {
      state.view = {}; // or null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLogin.fulfilled, (state, action) => {
        state.status = "succeeded";
        switch (action.payload.API_Name) {
          case "login":
            state.login = action.payload.status;
            state.barToken = action.payload.data;
            localStorage.setItem("consumerSite_token", action.payload.data);
            // state.tokenExpiration = Date.now() + 1800000;
            return state;
          case "registerUser":
            state.registerUser = action.payload.response.status;
            return state;
          case "buyBack":
            state.buyBack = action.payload.response.status;
            state.success = action.payload.response.data.message;
            return state;
          case "forgotPassword":
            state.forgotPassword = action.payload.status;
            return state;
          case "currentUser":
            state.currentUser = action.payload.response.data;
            localStorage.setItem(
              "auth.currentUser",
              JSON.stringify(action.payload.response.data)
            );
            return state;
          case "updateUser":
            state.updateUser = action.payload.response.data;
            return state;
          case "view":
            state.view = action.payload.response.data;
            return state;
          case "partnerSiteId":
            state.partnerSiteId = action.payload.response.data;
            let data = {
              ...action.payload.response.data,
              siteId: action.payload.payload,
            };
            sessionStorage.setItem("partnerSiteId", JSON.stringify(data));
            return state;
          case "purchase":
            state.purchase = action.payload.response.data;
            return state;
          case "voucher":
            state.voucher = action.payload.response.data;
            return state;
          case "voucherPurchase":
            state.voucherPurchase = action.payload.response.data;
            return state;
          case "paypalAuthorize":
            state.paypalAuthorize = action.payload.response.data;
            localStorage.setItem(
              "doPaypalPurchaseValue",
              JSON.stringify(action.payload.payload)
            );
            state.doPaypalPurchaseValue = action.payload.payload;
            return state;
          case "doPaypalPurchase":
            state.doPaypalPurchase = action.payload.response.data;
            return state;
          case "resetPassword":
            state.resetPassword = action.payload.response.data;
            break;
          default:
            break;
        }
      })
      .addCase(fetchLogin.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(fetchLogin.rejected, (state, action) => {
        if (action.meta.arg.condition === "view") {
          state.view = {};
        }
        state.status = "failed";
        if (action.meta.arg.condition === "forgotPassword") {
          state.forgotPassword = action.error.message;
        } else if (action.meta.arg.condition === "resetPassword") {
          state.resetPassword = { error: action.error.message };
        } else {
          state.error = action.error.message;
        }
      });
  },
});

export const { clearData, clearView } = loginSlice.actions;

export default loginSlice.reducer;
